export default __webpack_public_path__ + "static/media/Spring21_17.742ef392.png";